// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3CA3c","errors":"Errors_errors__MlYBW"};